import { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SharedUI';
import { AgeGateModal, LightboxModal } from '../ui/Modals';

const galleryImages = [
  "/emilia-2.webp", "/emilia-3.webp", "/emilia-5.webp",
  "/emilia-10.webp", "/emilia-11.webp", "/emilia-12.webp",
  "/emilia-14.webp", "/emilia-16.webp", "/emilia-17.webp", "/emilia-20.webp"
];

export function PersonaGallery() {
  const [lightboxImg, setLightboxImg] = useState<string | null>(null);
  const [isAgeGateOpen, setIsAgeGateOpen] = useState(false);

  return (
    <>
      <AgeGateModal isOpen={isAgeGateOpen} onClose={() => setIsAgeGateOpen(false)} />
      <LightboxModal image={lightboxImg} onClose={() => setLightboxImg(null)} />

      <section className="relative z-10 w-full py-20 lg:py-32 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-12 items-end justify-between mb-16">
            <div>
              <SectionHeading title="Emilia Ivanova" subtitle="The Visionary" />
              <p className="mt-8 text-neutral-400 font-light leading-relaxed max-w-xl text-sm md:text-base">
                I am Emilia Ivanova. I live at the intersection of high fashion, digital art, and technological innovation. For my community of over 220,000 followers, my presence is a curated window into an uncompromising aesthetic and an aspirational lifestyle. But the visuals are only the surface. I represent the ultimate vision of this empire—proving that absolute elegance and highly advanced, scalable architecture are destined to merge.
              </p>
              <div className="mt-8 flex gap-6">
                <a href="https://instagram.com/emilia.ivanova_model" target="_blank" rel="noreferrer" className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white border-b border-white/30 hover:border-white transition-colors pb-1 md:cursor-none">
                  Instagram
                </a>
                <button onClick={(e) => { e.preventDefault(); setIsAgeGateOpen(true); }} className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white border-b border-white/30 hover:border-white transition-colors pb-1 md:cursor-none">
                  Exclusive
                </button>
              </div>
            </div>
          </div>

          {/* SHOWCASE GALLERY (Bento/Apple-Style Layout) */}
          <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[120px] sm:auto-rows-[200px] md:auto-rows-[250px] gap-2 md:gap-4 grid-flow-dense">
            {galleryImages.map((src, index) => {
              let spanClass = "col-span-1 row-span-1";
              const p = index % 10;
              if (p === 0 || p === 6) spanClass = "col-span-2 row-span-2"; // Large square
              else if (p === 3 || p === 8) spanClass = "col-span-2 row-span-1"; // Wide
              else if (p === 1 || p === 5) spanClass = "col-span-1 row-span-2"; // Tall

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: (index % 6) * 0.05 }}
                  className={`relative overflow-hidden bg-neutral-900 group md:cursor-pointer ${spanClass}`}
                  onClick={() => setLightboxImg(src)}
                >
                  <img
                    src={src.replace('.webp', '-thumb-opt.webp')}
                    alt={`Emilia Visual ${index}`}
                    loading="lazy"
                    width={574}
                    height={804}
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-all duration-700 group-hover:scale-105 transform-gpu"
                    onContextMenu={(e) => e.preventDefault()}
                    draggable={false}
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <span className="text-white border border-white/30 rounded-full w-8 h-8 flex items-center justify-center backdrop-blur-sm text-lg">+</span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
